// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectClaimsVsActualCosts  {
    _originalTypeClassName = "Loom.BO.ProjectClaimsVsActualCosts";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectClaimsVsActualCosts.translate = translateService;
}
this.EmployeeClaimsVsActualCosts = [];
this.Id = null;
this.ClaimedCosts = null;
this.ActualCosts = null;
this.ClaimedPMs = null;
this.ActualPMs = null;
this.PeriodStart = null;
this.PeriodEnd = null;
this.Project = null;
this.Beneficiary = null;
this.ActualDays = null;
this.ActualHours = null;
this.PnL = null;
this.EffortGap = null;
this.PnLPercentage = null;
this.EffortGapPercentage = null;
this.Category = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ClaimedCosts:any;
ActualCosts:any;
ClaimedPMs:any;
ActualPMs:any;
PeriodStart:any;
PeriodEnd:any;
Project:any;
Beneficiary:any;
ActualDays:any;
ActualHours:any;
PnL:any;
EffortGap:any;
PnLPercentage:any;
EffortGapPercentage:any;
Category:any;
EmployeeClaimsVsActualCosts:any;
static setEmployeeClaimsVsActualCosts = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmployeeClaimsVsActualCosts == null) $this.EmployeeClaimsVsActualCosts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmployeeClaimsVsActualCosts.length > 0) {
                    Domain.ProjectClaimsVsActualCosts.removeEmployeeClaimsVsActualCosts($this, $this.EmployeeClaimsVsActualCosts[0]);
                }

                Domain.ProjectClaimsVsActualCosts.addManyEmployeeClaimsVsActualCosts($this, copyItems);
            }
static addManyEmployeeClaimsVsActualCosts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectClaimsVsActualCosts.addEmployeeClaimsVsActualCosts($this, items[i]);
                }
            }
static addEmployeeClaimsVsActualCosts = ($this, item) => {
                if ($this.EmployeeClaimsVsActualCosts == null) $this.EmployeeClaimsVsActualCosts = [];
                if (item == null || $this.EmployeeClaimsVsActualCosts.indexOf(item) > -1) return;
                $this.EmployeeClaimsVsActualCosts.push(item);
Domain.EmployeeClaimsVsActualCosts.addProjectClaimsVsActualCosts(item, $this);
}
static addRangeEmployeeClaimsVsActualCosts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectClaimsVsActualCosts.addEmployeeClaimsVsActualCosts($this, item));
            }
static removeEmployeeClaimsVsActualCosts = ($this, item) => {
                if ($this == null || $this.EmployeeClaimsVsActualCosts == null || $this.EmployeeClaimsVsActualCosts.indexOf(item) === -1) return;
                var _index = $this.EmployeeClaimsVsActualCosts.indexOf(item);
                $this.EmployeeClaimsVsActualCosts.splice(_index, 1);
Domain.EmployeeClaimsVsActualCosts.removeProjectClaimsVsActualCosts(item, $this);
}
static clearEmployeeClaimsVsActualCosts = ($this) => { $this.EmployeeClaimsVsActualCosts = null; }

static GetEffortGap($this: any): any{return Joove.Common.safeNumber($this?.ClaimedPMs) - Joove.Common.safeNumber($this?.ActualPMs);
}
static GetEffortGapPercentage($this: any): any{return (CLMS.Framework.Number.GreaterThan(() => $this.ClaimedPMs, () => 0) ? Joove.Common.safeNumber(Domain.ProjectClaimsVsActualCosts.GetEffortGap($this)) / Joove.Common.safeNumber($this?.ClaimedPMs) : 0.0);
}
static GetPnL($this: any): any{return Joove.Common.safeNumber($this?.ClaimedCosts) - Joove.Common.safeNumber($this?.ActualCosts);
}
static GetPnLPercentage($this: any): any{return (CLMS.Framework.Number.GreaterThan(() => $this.ClaimedCosts, () => 0) ? Joove.Common.safeNumber(Domain.ProjectClaimsVsActualCosts.GetPnL($this)) / Joove.Common.safeNumber($this?.ClaimedCosts) : 0.0);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}